module.exports = __webpack_public_path__ + "img/172420.4f6b698f.png";